// imports
import CRMultiSelect from 'minsky-kit/js/components/CRMultiSelect';
import WADDrupalView from './WADDrupalView';
import { removeElWithCrumb, resetElToCrumb } from '../utils/dom';
// private statics

// class definition
export default class WorkOverlview extends WADDrupalView {
    // constructor
    constructor (args = {}, objectName = 'WorkOverview') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._initialized = false;
        this._allowMultiSelect = true;
        this._catFilter = null;
        this._$catField = null;
        this._$renderedElements = [];
        this._filterSubmitPrevented = false;

        // add listener
        this.on('view_refresh', onViewLoaded);

        // init self
        initView.call(this);
    }

    // methods
    refresh () {
        contentHeightCorrection.call(this);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils
function initView () {
    // grab filter submit button
    this._$submitBtn = this.$el.querySelector('.view-exposed .form-actions .form-submit');

    // parse filter options
    const $journeyDataEl = this.$el.querySelector('[data-wf-journey-options]');
    if ($journeyDataEl) {
        const journeyData = JSON.parse($journeyDataEl.dataset.wfJourneyOptions);

        // look for category filter
        const $catItem = this.$el.querySelector('.form-item-category');

        // get & hide original field
        const $field = this.$el.querySelector('.form-text');
        $field.style.display = 'none';
        const values = $field.value.split('+').map((item) => (item ? parseInt(item) : ''));

        // render multiselect
        const $select = document.createElement('select');
        const options = [];
        journeyData.forEach((item) => {
            options.push(`<option value="${item.nid}" ${values.indexOf(parseInt(item.nid)) > -1 ? 'selected' : ''}>${item.title}</option>`);
        });
        $select.multiple = this._allowMultiSelect;
        $select.innerHTML = options.join('');
        $catItem.appendChild($select);
        this._$renderedElements.push($select);

        // init filter
        this._catFilter = new CRMultiSelect({
            $el:    $select,
            addAll: `${Drupal.t('minskyString.work-overview.category-filter.label.all')}`,
        });

        this._$catField = $field;

        // add a all option to the select that would match the rendered all value of the filter instance
        $select.innerHTML = `<option value="" class="option--all">${Drupal.t('minskyString.work-overview.category-filter.label.all')}</option>${$select.innerHTML}`;

        // if field has no value => ensure only all is selected
        if (this._$catField.value === '') {
            // $select.options[0].selected = true;
            this._filterSubmitPrevented = true;
            this._catFilter.$el.querySelector('input[value="_all_"]').click();
        }

        // add listener
        this._catFilter.on('change', this.blm.add('onCatFilterChange', onCatFilterChange));

        // set it ready
        $catItem.classList.add('form-item-category--ready');
        this._catFilter.$el.classList.add('cr-multi-select--category');
    }

    // correct view content padding if items overflow at the bottom due to relative shift of even items
    contentHeightCorrection.call(this);

    // add click listener to pager so we can disable the view
    this.$el.querySelectorAll('.pager .pager__link').forEach(($pagerItem) => {
        $pagerItem.addEventListener('click', this.blm.addOnce('onPagerClick', onPagerClick));
    });

    // add listener using jquery from the module to know when new content arrived
    if (window['jQuery']) jQuery('.view--work-overview').on('views_infinite_scroll.new_content', this.blm.addOnce('newContentAppended', newContentAppended));

    this._initialized = true;
}

function destroyView () {
    this._initialized = false;
}

function enableView () {
    this.$view.style.pointerEvents = null;
    this.$view.style.opacity = null;
}

function disableView () {
    this.$view.style.pointerEvents = 'none';
    this.$view.style.opacity = 0.5;
}

function contentHeightCorrection () {
    const $content = this.$el.querySelector('.view-content');
    $content.style.paddingBottom = 0;
    const $lastRow = this.$el.querySelector('.views-row:last-child');

    if ($lastRow) {
        const contentBB = $content.getBoundingClientRect();
        const lastRowBB = $lastRow.getBoundingClientRect();
        const overflow = Math.abs(lastRowBB.top - contentBB.top) + lastRowBB.height - contentBB.height;
        if (overflow > 0) $content.style.paddingBottom = `${overflow}px`;
    }
}

// Event handlers
function onViewLoaded () {
    if (this._initialized) destroyView.call(this);
    initView.call(this);
}

function onCatFilterChange () {
    this._$catField.value = Array.from(this._catFilter.$select.options)
        .filter(($option) => $option.selected)
        .map(($option) => $option.value)
        .join('+');

    if (this._$catField.value === '_all_') this._$catField.value = '';
    if (this._$submitBtn && !this._filterSubmitPrevented) {
       
        removeElWithCrumb(this._catFilter.$el);
        this._$submitBtn.click();
        resetElToCrumb(this._catFilter.$el);
        disableView.call(this);
    }
    this._filterSubmitPrevented = false;
}

function onPagerClick () {
    disableView.call(this);
}

function newContentAppended () {
    enableView.call(this);
}
